/* eslint-disabled no-unused-vars */
import { apolloClient } from '@/setup/apollo-setup';
import { error } from '@/utils/notification';

import {
  // ADD_STUDENT,
  // DELETE_STUDENT,
  // GET_STUDENTS,
  GET_STUDENTS_BY_FILTER,
  // GET_STUDENT,
  // UPDATE_STUDENT,
} from '@/queries/modules/profile/student';

//
// initial state
const state = {
  processing: false,
  error: null,
  success: null,
};

//
// getters
const getters = {
  // getField
};

//
// mutations
const mutations = {
  // updateField,
  clearError: (state) => {
    state.error = null;
  },
  setError: (state, payload) => {
    state.error = payload;
    state.success = null;
    state.processing = false;
  },
  setSuccess: (state, payload) => {
    state.error = null;
    state.success = payload;
    state.processing = false;
  },
  setProcessing: (state, payload) => {
    state.processing = payload;
  },
  /* setTeachers: (state, payload) => {
    state.teachers = payload ? payload : [];
    state.searchTeacherResults = payload ? payload : [];
  }, */
  /* setTeacher: (state, payload) => {
    state.teacher = payload;
  }, */
  /* setSelectedTeacher: (state, payload) => {
    state.teacher = {...payload};
  }, */
  /* setSearchTeacherResults: (state, payload) => {
    state.searchTeacherResults = payload;
  }, */
  /* clearSelectedTeacher: (state) => {
    state.teacher = {
      id: "",
      code: "",
      facultyId: "",
      curriculumId: "",
      prefixId: "",
      firstNameLocal: "",
      lastNameLocal: "",
      firstNameEng: "",
      lastNameEng: "",
      availableTime: "",
      telephone: "",
      email: "",
      picturePath: "",
      socialMedia: "",
      isSpecialTeacher: null,
      isActive: null,
      userId: "",
    }
  } */
};

//
// actions
const actions = {
  async getStudentsByFilter ({commit}, payload) {
    commit('setProcessing', true);
    try {
      const result = await apolloClient
        .query({
          query: GET_STUDENTS_BY_FILTER,
          variables: payload,
          fetchPolicy: 'network-only'
        })
      const { data } = await result;
      if (data) {
        // TODO: Handle after success;
        commit('setSuccess', true);
        return { status: { success: true, error: false, message: "" }, data: [...data.getStudentsByFilter] }
      } else {
        return { status: { success: false, error: true, code: 400, message: "no-result" }}
      }
    } catch (e) {
      commit('setError', error(e));
      return { status: { success: false, error: true, message: "", full: e }}
    }
  },
  // getTeachersByFilterNotUseState: async ({commit}, payload) => {
  //   commit('setProcessing', true);
  //   try {
  //     const result = await apolloClient
  //       .query({
  //         query: GET_TEACHERS_BY_FILTER,
  //         variables: payload
  //       });
  //     const { data } = await result;
  //     commit('setSuccess', null);
  //     if (data && data.getTeachersByFilter.length > 0) {
  //       // TODO: Handle after success;
  //       return { status: { success: true, error: false, message: "" }, data: [...data.getTeachersByFilter] }
  //     } else {
  //       return { status: { success: false, error: true, code: 400, message: "no-result" }, data: []}
  //     }
  //   } catch (e) {
  //     console.log(e);
  //     commit('setError', error(e));
  //     return { status: { success: false, error: true, message: "", full: e }}
  //   }
  // },
  // getTeacher: async ({commit}, id) => {
  //   commit('setProcessing', true);

  //   apolloClient
  //     .query({
  //       query: GET_TEACHER,
  //       variables: {
  //         id: id
  //       }
  //     })
  //     .then(({data}) => {
  //       commit('setTeacher', data.getTeacher);
  //       commit('setSuccess', null);
  //     })
  //     .catch(({err}) => {
  //       commit('setError', error(err));
  //     });
  // },
  // searchTeachers: async ({commit}, payload) => {
  //   commit('setProcessing', true);

  //   try {
  //     commit('setSearchTeacherResults', _.filter(state.teachers, (teacher) => _.some(teacher, value => _.includes(_.toLower(value), _.toLower(payload)))));
  //     commit('setProcessing', false);
  //   } catch (err) {
  //     console.log(err);
  //     commit('setError', error(err));
  //   }
  // },
  // addTeacher: async ({commit}, payload) => {
  //   commit('setProcessing', true);

  //   await apolloClient
  //     .mutate({
  //       mutation: ADD_TEACHER,
  //       variables: payload,
  //     })
  //     .then(({data}) => {
  //       const teachers = [...state.teachers];
  //       teachers.push(data.addTeacher);
  //       commit('setTeachers', teachers);
  //       commit('setSuccess', newItemSuccess(data.addTeacher.nameLocal));
  //     })
  //     .catch((err) => {
  //       commit('setError', error(err));
  //     });
  // },
  // updateTeacher: async ({commit}, payload) => {
  //   commit('setProcessing', true);

  //   apolloClient
  //     .mutate({
  //       mutation: UPDATE_TEACHER,
  //       variables: payload
  //     })
  //     .then(({data}) => {
  //       const index = state.teachers.findIndex(teacher => teacher.id === data.updateTeacher.id);
  //       const teachers = [
  //         ...state.teachers.slice(0, index),
  //         data.updateTeacher,
  //         ...state.teachers.slice(index + 1)
  //       ];

  //       commit('setTeachers', teachers);
  //       commit('setSuccess', updateItemSuccess(data.updateTeacher.nameLocal));
  //     })
  //     .catch(({err}) => {
  //       commit('setError', error(err));
  //     });
  // },
  // deleteTeacher: async ({commit}, payload) => {
  //   commit('setProcessing', true);

  //   apolloClient
  //     .mutate({
  //       mutation: DELETE_TEACHER,
  //       variables: payload
  //     })
  //     .then(({data}) => {
  //       const index = state.teachers.findIndex(teacher => teacher.id === data.deleteTeacher.id);
  //       const teachers = [
  //         ...state.teachers.slice(0, index),
  //         ...state.teachers.slice(index + 1)
  //       ];

  //       commit('setTeachers', teachers);
  //       commit('setSuccess', deleteItemSuccess(data.deleteTeacher.nameLocal));
  //     })
  //     .catch(({err}) => {
  //       commit('setError', error(err));
  //     });
  // },
  // selectedTeacher: async ({commit}, payload) => {
  //   commit('setSelectedTeacher', payload);
  // },
  // clearSelectedTeacher: async ({commit}) => {
  //   commit('clearSelectedTeacher');
  // }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
